import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot
} from '@angular/router';
import { PermissionType } from '../_enums/permissionType';
import { RoleAccessService } from './role.access.service';
@Injectable({
  providedIn: 'root'
})
export class AccessGuardService implements CanActivate {
  constructor(public roleService: RoleAccessService, public router: Router) {

  }


  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> | boolean {
    // this will be passed from the route config
    //

    const roleItem = route.data.roleItem;
    const accessType = route.data.accessType;
    let isAccessAllowed = this.hasRequiredPermission(roleItem, accessType);

    if (accessType != PermissionType.Accesss && isAccessAllowed) {
      isAccessAllowed = this.hasRequiredPermission(roleItem, PermissionType.Accesss);
    }

    return isAccessAllowed;
    // return this.hasRequiredPermission(roleItem, accessType);
  }

  // canActivate(route: ActivatedRouteSnapshot): boolean {
  //  // this will be passed from the route config
  //  //
  //  const roleItem = route.data.roleItem;
  //  let accessType = route.data.accessType;

  //  if (!this.roleService.HasAccess(roleItem, accessType)) {
  //    this.router.navigate(['NoAccess']);
  //    return false;
  //  }
  //  return true;
  // }
  protected hasRequiredPermission(roleItem: string, accessType: any): Promise<boolean> | boolean {
    // If user’s permissions already retrieved from the API

    if (this.roleService.IsPermissionsExists()) {
      if (!this.roleService.HasAccess(roleItem, accessType)) {
        this.router.navigate(['NoAccess']);
        return false;
      }
      return true;
    } else {
      // Otherwise, must request permissions from the API first
      const promise = new Promise<boolean>((resolve, reject) => {

        this.roleService.initializePermissions()
          .then(() => {
            if (!this.roleService.HasAccess(roleItem, accessType)) {
              this.router.navigate(['NoAccess']);
              return false;
            }
            return true;
          }).catch(() => {
            resolve(false);
          });
      });
      return promise;
    }
  }
}
